import { PropsWithChildren } from "react";

/**
 * Causes it's immediate children to `flex-grow` and fill any available space in the main axis.
 */
export function Grow(props: PropsWithChildren) {
  return <div className="contents [&>*]:grow" {...props} />;
}
